export default "__VITE_ASSET__CX2r4z_f__"